import React, { useMemo } from 'react';
import { MetricSelectorPopup } from '@components/common';
import { useDispatch, useSelector } from 'react-redux';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { refreshTrends } from '@store/common/actions';
import { supportedMetricsSelector } from '@store/common/selectors';
import { setDimensionMetrics } from '@store/trends/base/actions';
import { dimensionMetricsSelector, globalOrderBySelector } from '@store/trends/base/selectors';
import { metricsCountLimit } from '@store/trends/base/dimensionSaga';
import { uniq } from 'lodash';

function MetricSelector() {
  const dispatch = useDispatch();
  const supportedMetrics: Record<string, any> = useSelector(supportedMetricsSelector);
  const metrics = useSelector(dimensionMetricsSelector);
  const metric = useSelector(selectedMetricSelector);
  const orderBy = useSelector(globalOrderBySelector);

  const onApply = (metrics, kpiChanged) => {
    dispatch(setDimensionMetrics(metrics));
    // refresh data on page
    if (kpiChanged) {
      refreshTrends();
    }
  };

  // metric filter replaces applied metrics with pre-defined metrics
  // primary metric should be locked only if it's checked
  const lockedMetrics = useMemo(() => {
    return uniq([metric, orderBy]).filter((m) => metrics.includes(m));
  }, [metric, orderBy, metrics]);

  return (
    <MetricSelectorPopup
      supportedMetrics={supportedMetrics}
      selectedMetrics={metrics}
      lockedMetrics={lockedMetrics}
      onApply={onApply}
      metricsCountLimit={metricsCountLimit}
    />
  );
}

export default MetricSelector;
